var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    attrs: {
      "error-messages": _vm.validationMessage,
      items: _vm.contextCountries,
      label: _vm.contextLabel,
      rules: _vm.rules,
      readonly: _vm.$store.state.Delegation.readonly === true
    },
    model: {
      value: _vm.contextModel,
      callback: function($$v) {
        _vm.contextModel = $$v
      },
      expression: "contextModel"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }